export default {
    name: '同心映像',
    listTitle: '同心映像列表',
    url: '/impression', // rest接口表名
    query: '&sort=sort,-id', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '标题', dataIndex: 'title'},
            {
                title: '封面',
                dataIndex: 'img',
                customRender: text => {
                    return <img class="avatar" src={text} />
                }
            },
            {title: '排序', dataIndex: 'sort'},
        ]
    },
    // 列表查询表单
    queryForm: [],
    // 新增/编辑查询表单
    items: [
        {
            key: 'title',
            label: '标题',
            component: 'a-input',
            props: {
                placeholder: '请输入标题',
            },
            rules: [{ required: true, message: '请输入标题', trigger: 'blur' }]
        },
        {
            key: 'url',
            label: '视频上传',
            component: 'form-upload',
            props: {
                mediaType: 'video'
            },
            rules: [{ required: true, message: '请上传视频', trigger: 'change' }]
        },
        {
            key: 'img',
            label: '视频封面',
            component: 'form-upload',
            rules: [{ required: true, message: '请上传视频封面', trigger: 'change' }]
        },
        {
            key: 'sort',
            label: '排序',
            component: 'a-input-number',
            props: {
                placeholder: '数字越小排位越前',
            },
            style: {
                width: '240px'
            },
        },
    ],
    init: {},
    // 详情接口expand字段
    expand: '',
    renderItems: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {
                label: '标题',
                key: 'name'
            },
            {
                label: '视频',
                key: 'url',
                slot: entity => {
                    return <div class="video-preview">
                        <video poster={entity.img} controls src={entity.url}></video>
                    </div>
                },
            },
            {
                label: '排序',
                key: 'sort'
            },
        ]
    }
}
